import React from "react";
import { useNavigate } from "react-router-dom";
import "../../../Styles/insights/GoodHires.css";

export default function GoodHires() {
    const navigate = useNavigate();
    return (
        <div className="goodhires-outer">
            <div className="goodhires-header-section">
                <h1 className="goodhires-title">
                    When Good Hires Go Wrong: The Truth About Gut Decisions
                </h1>
            </div>
            <div className="goodhires-mainrow">
                <div className="goodhires-mainimg-container">
                    <img src="/assets/insights/goodhires.png" alt="Good Hires" className="goodhires-mainimg" />
                </div>
                <div className="goodhires-sidecard">
                    <div className="goodhires-sidecard-badge">
                        <img src="/assets/Badge_TM.png" alt="Certified Badge" className="goodhires-badge-img" />
                    </div>
                    <div className="goodhires-sidecard-bg">
                        <img src="/assets/insights/goodhires_side.jpg" alt="Team" />
                    </div>
                    <div className="goodhires-sidecard-content">
                        <h3>Earn the Outstanding<br /><span>Workplaces Certification</span></h3>
                        <ul>
                            <li>Attract Top Talent</li>
                            <li>Boost Employee Engagement</li>
                            <li>Drive Culture-Led Growth</li>
                        </ul>
                        <button className="goodhires-sidecard-btn" onClick={() => navigate('/nominate')}>Get Certificate</button>
                    </div>
                </div>
            </div>
            <div className="goodhires-share">
                <span>Share :</span>
                <img
                    src="/icons/insightstwitter.png"
                    alt="Twitter"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        const url = encodeURIComponent(window.location.href);
                        window.open(`https://twitter.com/intent/tweet?url=${url}`, '_blank', 'noopener,noreferrer');
                    }}
                />
                <img
                    src="/icons/insightslinkedin.png"
                    alt="LinkedIn"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        const url = encodeURIComponent(window.location.href);
                        window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${url}`, '_blank', 'noopener,noreferrer');
                    }}
                />
                <img
                    src="/icons/insightsfacebook.png"
                    alt="Facebook"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        const url = encodeURIComponent(window.location.href);
                        window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank', 'noopener,noreferrer');
                    }}
                />
                <img
                    src="/icons/insightswhatsapp.png"
                    alt="WhatsApp"
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                        const url = encodeURIComponent(window.location.href);
                        window.open(`https://wa.me/?text=${url}`, '_blank', 'noopener,noreferrer');
                    }}
                />
            </div>
            <div className="goodhires-content-section">
                <h2 className="goodhires-content-title">Many companies rely on intuition when hiring developers, but gut feelings often mislead. Even candidates who excel in interviews can underperform on the job. Evidence-based hiring—using data, structured processes, and technical rigor—reduces risk, improves productivity, and transforms hiring from a gamble into a predictable, reliable process.</h2>
                <h3>Why Gut Instinct Fails in Tech Hiring</h3>
                <ul>
                    <li>Explore why relying on intuition often leads to poor hiring outcomes and how evidence-based approaches improve team performance.</li>
                </ul>
                <h3>The Cost of a Bad Hire: Productivity and Beyond</h3>
                <ul>
                    <li>Break down the hidden costs of wrong hiring decisions, from project delays to lowered morale.</li>
                </ul>
                <h3>Data-Driven Hiring: From Guesswork to Strategy</h3>
                <ul>
                    <li>Discuss how structured assessments, coding tests, and analytics can reduce hiring risks.</li>
                </ul>
                <h3>Structured Interviews: Making Every Question Count</h3>
                <ul>
                    <li>Showcase techniques for standardized interviews that objectively measure candidate potential.</li>
                </ul>
                <h3>Building a High-Performance Team Through Evidence-Based Recruitment</h3>
                <ul>
                    <li>Illustrate how careful selection impacts overall team efficiency and company culture.</li>
                </ul>
                <h3>Balancing Skills and Culture Fit in Developer Hiring</h3>
                <ul>
                    <li>Examine the tension between technical expertise and alignment with workplace values.</li>
                </ul>
                <h3>Common Hiring Biases and How to Avoid Them</h3>
                <ul>
                    <li>Identify cognitive and cultural biases that influence instinctive hiring choices.</li>
                </ul>
                <h3>Onboarding Matters: When the Right Hire Needs the Right Start</h3>
                <ul>
                    <li>Show how structured onboarding complements evidence-based hiring to ensure success.</li>
                </ul>
                <h3>Continuous Feedback Loops: Learning From Hiring Outcomes</h3>
                <ul>
                    <li>Advocate tracking performance post-hire to refine recruitment strategies over time.</li>
                </ul>
                <h3>From Gamble to Science: Transforming Recruitment in Tech Teams</h3>
                <ul>
                    <li>A forward-looking piece on integrating analytics, structured evaluation, and technical rigor into hiring processes.</li>
                </ul>
            </div>
        </div>
    );
}
